import { Construction, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ComingSoon({ title }) {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center text-center">
      <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-white shadow-sm border border-slate-200">
        <Construction className="h-8 w-8" style={{ color: "#0057A8" }} />
      </div>
      <div className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[#0057A8]">Phase 2</div>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900">{title}</h1>
      <p className="mt-2 max-w-md text-sm text-slate-500">
        The <strong>{title}</strong> module is coming in the next phase. The data architecture is already in place — leads created today will flow seamlessly into this module.
      </p>
      <Link to="/dashboard" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0057A8]">
        Back to Dashboard <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
